import packageJson from '../package.json'

const config = {
    version: packageJson.version,
    apiBaseUrl: "https://ipanel02.app.okeoke.io/"
}

export default config
